"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initializeConnection;

var _url = _interopRequireDefault(require("url"));

var _socket = require("socket.io-client");

var _log = _interopRequireDefault(require("../shared/log"));

var _getCookies = _interopRequireDefault(require("../shared/getCookies"));

var _isNodeJS = _interopRequireDefault(require("../shared/isNodeJS"));

var _parser = _interopRequireDefault(require("../shared/parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function initializeConnection(_x) {
  return _initializeConnection.apply(this, arguments);
}

function _initializeConnection() {
  _initializeConnection = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(client) {
    var theClient, actionOpts, subscriptionOpts, isMonolithic, clientUrl, clientActionUrl, clientSubscriptionUrl;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(client.actionSocket && client.subscriptionSocket)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", true);

          case 2:
            theClient = client;
            actionOpts = {
              auth: {
                authToken: theClient.authToken
              },
              withCredentials: true
            };
            subscriptionOpts = {
              auth: {
                authToken: theClient.authToken
              },
              withCredentials: true
            };
            isMonolithic = theClient.url;

            if (!isMonolithic) {
              _context.next = 28;
              break;
            }

            clientUrl = _url["default"].resolve(theClient.url, '/data'); // If the client run in nodejs environment then we have to set the cookies manually

            if (!(0, _isNodeJS["default"])()) {
              _context.next = 13;
              break;
            }

            _context.next = 11;
            return (0, _getCookies["default"])(clientUrl, actionOpts);

          case 11:
            _context.t0 = _context.sent;
            actionOpts.extraHeaders = {
              Cookie: _context.t0
            };

          case 13:
            theClient.actionSocket = (0, _socket.io)(clientUrl, _objectSpread(_objectSpread({}, actionOpts), {}, {
              parser: _parser["default"],
              transports: ['websocket', 'polling']
            }));
            theClient.subscriptionSocket = theClient.actionSocket;
            _context.prev = 15;
            _context.next = 18;
            return new Promise(function (resolve, reject) {
              theClient.actionSocket.on('connect_error', function (err) {
                theClient.disconnect();
                (0, _log["default"])("Error while connecting to a monolithic server.Err: ".concat(err, "."));
                reject(err);
              });
              theClient.actionSocket.on('authDone', function (role) {
                if (!theClient.role) {
                  theClient.role = role;
                }

                resolve();
              });
            });

          case 18:
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](15);
            theClient.onAuthTokenFailure("Error while connecting to a monolithic server.Err: ".concat(_context.t1.message));
            return _context.abrupt("return", false);

          case 24:
            theClient.actionSocket.on('disconnect', function (reason) {
              if (reason === 'io server disconnect') {
                theClient.onAuthTokenFailure('Token expired');
              }

              theClient.disconnect();
            });
            theClient.actionSocket.on('remoteError', function (_ref) {
              var errCode = _ref.errCode,
                  errMessage = _ref.errMessage;
              return theClient.onRemoteError(errCode, errMessage);
            });
            _context.next = 63;
            break;

          case 28:
            clientActionUrl = _url["default"].resolve(theClient.actionUrl, '/data');
            clientSubscriptionUrl = _url["default"].resolve(theClient.subscriptionUrl, '/data');

            if (!(0, _isNodeJS["default"])()) {
              _context.next = 39;
              break;
            }

            _context.next = 33;
            return (0, _getCookies["default"])(clientActionUrl, actionOpts);

          case 33:
            _context.t2 = _context.sent;
            actionOpts.extraHeaders = {
              Cookie: _context.t2
            };
            _context.next = 37;
            return (0, _getCookies["default"])(clientSubscriptionUrl, subscriptionOpts);

          case 37:
            _context.t3 = _context.sent;
            subscriptionOpts.extraHeaders = {
              Cookie: _context.t3
            };

          case 39:
            theClient.actionSocket = (0, _socket.io)(clientActionUrl, _objectSpread(_objectSpread({}, actionOpts), {}, {
              parser: _parser["default"],
              transports: ['websocket', 'polling']
            }));
            _context.prev = 40;
            _context.next = 43;
            return new Promise(function (resolve, reject) {
              theClient.actionSocket.on('connect_error', function (err) {
                theClient.disconnect();
                (0, _log["default"])("Error while connecting to an aggregation server.Err: ".concat(err));
                reject(err);
              });
              theClient.actionSocket.on('authDone', function (role) {
                if (!theClient.role) {
                  theClient.role = role;
                }

                resolve();
              });
            });

          case 43:
            _context.next = 49;
            break;

          case 45:
            _context.prev = 45;
            _context.t4 = _context["catch"](40);
            theClient.onAuthTokenFailure("Error while connecting to an aggregation server.Err: ".concat(_context.t4.message));
            return _context.abrupt("return", false);

          case 49:
            theClient.subscriptionSocket = (0, _socket.io)(clientSubscriptionUrl, _objectSpread(_objectSpread({}, subscriptionOpts), {}, {
              parser: _parser["default"],
              transports: ['websocket', 'polling']
            }));
            _context.prev = 50;
            _context.next = 53;
            return new Promise(function (resolve, reject) {
              theClient.subscriptionSocket.on('connect_error', function (err) {
                theClient.disconnect();
                (0, _log["default"])("Error while connecting to an synchronization server.Err: ".concat(err));
                reject(err);
              });
              theClient.subscriptionSocket.on('authDone', function (role) {
                if (!theClient.role) {
                  theClient.role = role;
                }

                resolve();
              });
            });

          case 53:
            _context.next = 59;
            break;

          case 55:
            _context.prev = 55;
            _context.t5 = _context["catch"](50);
            theClient.onAuthTokenFailure("Error while connecting to an synchronization server.Err: ".concat(_context.t5.message));
            return _context.abrupt("return", false);

          case 59:
            theClient.actionSocket.on('disconnect', function () {
              return theClient.disconnect();
            });
            theClient.subscriptionSocket.on('disconnect', function () {
              return theClient.disconnect();
            });
            theClient.actionSocket.on('remoteError', function (_ref2) {
              var errCode = _ref2.errCode,
                  errMessage = _ref2.errMessage;
              return theClient.onRemoteError(errCode, errMessage);
            });
            theClient.subscriptionSocket.on('remoteError', function (_ref3) {
              var errCode = _ref3.errCode,
                  errMessage = _ref3.errMessage;
              return theClient.onRemoteError(errCode, errMessage);
            });

          case 63:
            if (!(!theClient.sessionSubscription && theClient.subscriptionSocket)) {
              _context.next = 67;
              break;
            }

            _context.next = 66;
            return theClient.subscribe('meta/session', function (_ref4) {
              var id = _ref4.id;

              if (theClient.serverSessionID !== undefined && theClient.serverSessionID !== id) {
                theClient.onStateServerRestart();
              }

              theClient.serverSessionID = id;
            });

          case 66:
            theClient.sessionSubscription = _context.sent;

          case 67:
            return _context.abrupt("return", true);

          case 68:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[15, 20], [40, 45], [50, 55]]);
  }));
  return _initializeConnection.apply(this, arguments);
}